import {
  AddressOwnership,
  CustomerHomeAction,
  DataKey,
  Page,
  Property,
  PropertyValue,
  Shade,
  Sunlight,
  UpgradeSystem,
} from '../enums';

export const enphaseCustomer = {
  page: Page.EnphaseCustomer,
  dataKey: DataKey.EnphaseCustomer,
  heading: 'Are you an existing Enphase customer?',
  options: [
    {
      name: 'Yes',
      value: true,
      icon: 'yes',
      iconHover: 'yesHover',
      nextPage: Page.EnlightenLogin,
    },
    {
      name: 'No',
      value: false,
      icon: 'no',
      iconHover: 'noHover',
      nextPage: Page.Property,
    },
  ],
};

export const enlightenLogin = {
  page: Page.EnlightenLogin,
  heading: 'Please log in with your Enlighten ID.',
  enlightenId: {
    errorMessage: 'Please enter a valid email address.',
    label: 'enlightenId',
    placeholder: 'Enlighten ID',
    type: 'email',
  },
  enlightenPassword: {
    errorMessage: 'Incorrect username or password. Please try again.',
    label: 'enlightenPassword',
    placeholder: 'Password',
    type: 'password',
  },
  loginButton: {
    title: 'Login',
    type: 'submit',
  },
  forgotPassword: {
    text: 'Forgot password?',
    url: 'https://enlighten.enphaseenergy.com/forgot_password',
  },
  nextPage: Page.CustomerHome,
};

export const customerHome = {
  page: Page.CustomerHome,
  dataKey: DataKey.CustomerHome,
  heading: 'What are you interested in today?',
  options: [
    {
      name: CustomerHomeAction.UpgradeSystem,
      value: CustomerHomeAction.UpgradeSystem,
      icon: 'upgradeSystem',
      iconHover: 'upgradeSystemHover',
      nextPage: Page.UpgradeSystem,
    },
    {
      name: CustomerHomeAction.AddEVCharger,
      value: CustomerHomeAction.AddEVCharger,
      icon: 'iconEvCharger',
      iconHover: 'iconEvChargerHover',
      nextPage: Page.AddEVCharger,
    },
    {
      name: CustomerHomeAction.Support,
      value: CustomerHomeAction.Support,
      icon: 'support',
      iconHover: 'supportHover',
      nextPage: Page.TechnicalSupport,
    },
  ],
};

export const upgradeSystem = {
  page: Page.UpgradeSystem,
  dataKey: DataKey.UpgradeSystem,
  heading: 'How would you like to upgrade your solar system?',
  options: [
    {
      name: UpgradeSystem.Solar,
      value: UpgradeSystem.Solar,
      icon: 'solar',
      iconHover: 'solarHover',
      nextPage: Page.BatteryInstallationSite,
    },
    {
      name: UpgradeSystem.Battery,
      value: UpgradeSystem.Battery,
      icon: 'battery',
      iconHover: 'batteryHover',
      nextPage: Page.BatteryInstallationSite,
    },
    {
      name: UpgradeSystem.SolarAndBattery,
      value: UpgradeSystem.SolarAndBattery,
      icon: 'solarAndBattery',
      iconHover: 'solarAndBatteryHover',
      nextPage: Page.BatteryInstallationSite,
    },
    {
      name: UpgradeSystem.UpgradeMicroinverter,
      value: UpgradeSystem.UpgradeMicroinverter,
      icon: 'upgradeMicroinverter',
      iconHover: 'upgradeMicroinverterHover',
      nextPage: Page.UpgradeMicroinverters,
    },
  ],
};

export const upgradeMicroinverters = {
  page: Page.UpgradeMicroinverters,
  dataKey: DataKey.UpgradeMicroinverters,
  heading: 'Upgrade my microinverters',
  button: {
    title: 'Upgrade program',
    url: 'https://enphase.com/homeowners/home-solar-upgrade-program',
  },
};

export const addEVcharger = {
  page: Page.AddEVCharger,
  dataKey: DataKey.AddEVCharger,
  heading: 'Enphase IQ EV Chargers',
  button: {
    title: 'Find an EV charger',
    url: 'https://enphase.com/ev-chargers/home',
  },
};

export const technicalSupport = {
  page: Page.TechnicalSupport,
  dataKey: DataKey.TechnicalSupport,
  heading: 'Technical support',
  button: {
    title: 'Support',
    url: 'https://support.enphase.com/s/owner-home',
  },
};

export const batteryInstallationSite = {
  page: Page.BatteryInstallationSite,
  heading: 'Select your site.',
  placeholder: 'Select your site',
};

export const energyConsumption = {
  page: Page.EnergyConsumption,
  dataKey: DataKey.EnergyConsumption,
  heading: 'Energy consumption',
  inputData: {
    homeSize: {
      label: "What's your home size?",
      name: 'home_size',
      type: 'number',
      placeholder: '2100',
      unit: 'sq. ft.',
      maxLength: '4',
      errorMessage: 'Home size must be between 500 and 6,000 sq. ft.',
    },
    energyConsumption: {
      label: 'Estimated energy consumption',
      name: 'energy_consumption',
      type: 'number',
      placeholder: '30',
      unit: 'kWh/day',
      maxLength: '2',
    },
  },
  nextPage: Page.Success,
};

export const property = {
  page: Page.Property,
  dataKey: DataKey.Property,
  heading: 'What kind of property do you own?',
  options: [
    {
      name: Property.SingleFamilyHome,
      value: PropertyValue.SingleFamilyHome,
      icon: 'home',
      iconHover: 'homeHover',
      nextPage: Page.Sunlight,
    },
    {
      name: Property.CondoApartment,
      value: PropertyValue.CondoApartment,
      icon: 'condo',
      iconHover: 'condoHover',
      nextPage: Page.UnableToService,
    },
    {
      name: Property.MobileHome,
      value: PropertyValue.MobileHome,
      icon: 'mobile',
      iconHover: 'mobileHover',
      nextPage: Page.UnableToService,
    },
    {
      name: Property.Commercial,
      value: PropertyValue.Commercial,
      icon: 'commercial',
      iconHover: 'commercialHover',
      nextPage: Page.UnableToService,
    },
  ],
};

export const unableToService = {
  page: Page.UnableToService,
  heading: 'Sorry, we are unable to service you right now',
  bodyText:
    "Our estimator is only set up to provide preliminary estimates and installer information to residents of single family homes. Please click 'Close' to exit this form and learn more about going solar!",
  button: {
    title: 'Close',
    url: 'https://enphase.com/energy-101',
    urlDebranded: '/about-us',
  },
};

export const sunlight = {
  page: Page.Sunlight,
  dataKey: DataKey.Sunlight,
  heading: 'How much sunlight does your roof get?',
  options: [
    {
      name: Sunlight.ALot,
      value: Shade.NoShade,
      icon: 'alot',
      iconHover: 'alotHover',
      nextPage: Page.Address,
    },
    {
      name: Sunlight.Some,
      value: Shade.SomeShade,
      icon: 'some',
      iconHover: 'someHover',
      nextPage: Page.Address,
    },
    {
      name: Sunlight.NotMuch,
      value: Shade.LotOfShade,
      icon: 'notmuch',
      iconHover: 'notmuchHover',
      nextPage: Page.Address,
    },
    {
      name: Sunlight.Uncertain,
      value: Shade.Uncertain,
      icon: 'uncertain',
      iconHover: 'uncertainHover',
      nextPage: Page.Address,
    },
  ],
};

export const address = {
  page: Page.Address,
  heading: 'Enter your address',
  inputData: {
    streetAddress: {
      label: 'address',
      placeholder: '123 Main St.',
      errorMessage: 'Please enter a valid address.',
    },
    state: {
      label: 'state',
      placeholder: 'State',
      errorMessage: 'Please enter a valid state.',
      maxLength: '2',
    },
    zipCode: {
      label: 'zip',
      placeholder: 'ZIP Code',
      errorMessage: 'Please enter a valid ZIP code.',
      maxLength: '5',
    },
  },
  addressOwnership: {
    label: 'Do you own the property?',
    options: [
      { name: 'I own the property', value: AddressOwnership.Own },
      { name: 'I rent the property', value: AddressOwnership.Rent },
    ],
  },
  nextPage: Page.ElectricityBill,
};

export const electricityBill = {
  page: Page.ElectricityBill,
  dataKey: DataKey.ElectricityBill,
  heading: 'How much is your monthly electricity bill?',
  nextPage: Page.UtilityProvider,
};

export const utilityProvider = {
  page: Page.UtilityProvider,
  dataKey: DataKey.UtilityProvider,
  heading: 'Who is your electric utility provider?',
  placeholder: 'Select your utility provider',
  nextPage: Page.Email,
};

export const email = {
  page: Page.Email,
  dataKey: DataKey.Email,
  heading: 'Enter your email',
  options: [{ name: 'Email me a link to my report.', value: true }],
  nextPage: Page.Contact,
};

export const contact = {
  page: Page.Contact,
  dataKey: DataKey.Contact,
  heading: 'Enter your contact information',
  inputData: {
    fullName: {
      label: 'Full name',
      name: 'full_name',
      placeholder: 'First and last name',
      errorMessage: 'Please enter your first and last name.',
    },
    phone: {
      label: 'Phone',
      name: 'phone_number',
      placeholder: 'Enter your phone number',
      errorMessage: 'Please enter your phone number.',
      type: 'tel',
    },
  },
  privacyPolicyUrl: 'https://enphase.com/legal/privacy-policy',
  tosUrl: 'https://enphase.com/legal/terms-of-service',
  button: {
    title: 'See report and get estimates',
    type: 'submit',
  },
  nextPage: Page.Calculating,
};
